// extracted by mini-css-extract-plugin
export var features = "mobileFeatures-module--features--UIHeg";
export var featuresNav = "mobileFeatures-module--featuresNav--M9P5Z";
export var featuresIcons = "mobileFeatures-module--featuresIcons--ePeBt";
export var firstSlide = "mobileFeatures-module--firstSlide--peuaj";
export var featuresSlides = "mobileFeatures-module--featuresSlides--FR4F9";